import { Grid } from '@material-ui/core';
import { format } from 'date-fns';

// local imports
import { useInputChangeHandler } from 'app/hooks';
import { _capitalize } from 'app/utils/miscellaneous';
import { AsyncButton, FormInput, MaskedInput, AddPhoto, FormDatePicker } from '../../atoms';
import { FormatUtils } from 'app/utils';

const UpdateProfileForm = ({ loading, selectedFiles, setSelectedFiles, removeFile }) => {
  const { values, preventNonSpecialCharsInput } = useInputChangeHandler();

  // "birthdate" Datepicker Max Date
  const legalAge = FormatUtils.getLegalAgeDate();
  const legalAgeMsg = `${format(legalAge, 'dd/MM/yyy')} tarihinden öncesi seçilebilir.`;

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <FormInput
            id="profile_name"
            label="Ad"
            name="name"
            placeholder="Ad"
            disabled={loading}
            value={_capitalize(values?.name) || ''}
            onChange={preventNonSpecialCharsInput}
            maxLength={50}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <FormInput
            id="profile_surname"
            label="Soyad"
            name="surname"
            placeholder="Soyad"
            disabled={loading}
            value={_capitalize(values?.surname) || ''}
            onChange={preventNonSpecialCharsInput}
            maxLength={50}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <MaskedInput
            disabled={true}
            type="text"
            mask="+\90 \(999\) 999 99 99"
            maskChar="_"
            alwaysShowMask
            id="id_telephone"
            name="telephone"
            placeholder="Cep Telefonu"
            label="Cep Telefonu"
            value={values?.telephone || ''}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <FormInput
            disabled={true}
            id="profile_email"
            label="E-Posta Adresi"
            name="email"
            placeholder="E-Posta Adresi"
            value={values?.email || ''}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <FormDatePicker
            maxDate={legalAge}
            maxDateMessage={legalAgeMsg}
            disabled={loading}
            name="birthdate"
            label="Doğum Tarihi"
            value={values?.birthdate || ''}
          />
        </Grid>

        <Grid item xs={12}>
          <AddPhoto
            label="Profil Fotoğrafı"
            loading={loading}
            selectedFiles={selectedFiles}
            setSelectedFiles={setSelectedFiles}
            name="photo"
            removeFile={removeFile}
          />
        </Grid>

        <Grid item xs={12} className="flex justify-end">
          <AsyncButton icon="update" text="Güncelle" loading={loading} className="" />
        </Grid>
      </Grid>
    </>
  );
};

export default UpdateProfileForm;
